import { useState } from "react";

import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { UseCustomer_Data_Report } from "./Customer_DataReport/UseCustomer_DataReport";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useGetOrgUnitsData } from "../FSM/Beats_Patches/hooks/useBeat";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import {
  getCustomer_Data_Report,
  getPositionList,
} from "./Customer_DataReport/Customer_DataReport_Repo";
import { useOnboardingOutletTypesData } from "../Onboarding/hooks/useOnBoard";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { COLORS } from "../../constants/colors";
import { showToast } from "../../utils/toastUtils";

const Customer_Data_Report = () => {
  const { startPolling } = useExcelPolling();
  const [filterData, setFilterData] = useState({
    page: 1,
    limit: 10,
    search: "",
    positionId: null,
    outletTypeId: null,
    orgUnitId: null,
    action: "view",
  });

  const { data: OutletTypesData } = useOnboardingOutletTypesData({
    enable: true,
  });
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const {
    data: dataForCustomerReport,
    isLoading,
    isSuccess,
  } = UseCustomer_Data_Report({
    enable:
      !!filterData.search ||
      !!filterData.orgUnitId ||
      !!filterData.outletTypeId ||
      !!filterData.outletTypeId,
    param: {
      ...(filterData.orgUnitId === null || ""
        ? {}
        : { orgUnitId: filterData.orgUnitId }),
      ...(filterData.positionId === null || ""
        ? {}
        : { positionId: filterData.positionId }),
      ...(filterData.outletTypeId === null || ""
        ? {}
        : { outletTypeId: filterData.outletTypeId }),
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      page: filterData.page,
      limit: filterData.limit,
      action: filterData.action,
    },
  });

  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const outletType_DropDownData = OutletTypesData?.data
    ? [
        { id: "", label: "All" },
        ...Object.entries(OutletTypesData?.data || {}).map((item: any) => ({
          id: item[0],
          label: item[1],
        })),
      ]
    : [];

  const downloadExcelGet = async () => {
    const param = {
      ...(filterData.orgUnitId === null || ""
        ? {}
        : { orgUnitId: filterData.orgUnitId }),
      ...(filterData.positionId === null || ""
        ? {}
        : { positionId: filterData.positionId }),
      ...(filterData.outletTypeId === null || ""
        ? {}
        : { outletTypeId: filterData.outletTypeId }),
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      page: filterData.page,
      limit: filterData.limit,
      action: "download",
    };
    try {
      setLoadingExcel(true);
      const response = await getCustomer_Data_Report(param);
      const { success, fileDownloadId, intervalTime } =
        response.rowData.data || {};
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url: string) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFaled: (message: string) =>
            showToast.error(
              message || "onFalied error in Customer Data  report excel"
            ),
          onExpired: (message: string) =>
            showToast.error(
              message || "onExpired error in  Customer Data report excel"
            ),
          onDeleted: (message: string) =>
            showToast.error(
              message || "onDeleted error in Customer Data report excel "
            ),
        });
      }
    } catch (error: any) {
      console.log("Error while downloading excel in Customer Data report");
    }
  };

  const handleSearch = (val: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      search: val,
    }));
  };
  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
      limit: limit,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Customer Data Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        Title="Customer Data Report"
        filterFirstApporach={
          !!filterData.search ||
          !!filterData.orgUnitId ||
          !!filterData.outletTypeId ||
          !!filterData.outletTypeId
        }
        dynamicHeightOnRowsPerPage={true}
        showSpinner={isLoading}
        data={
          (!isLoading && isSuccess && dataForCustomerReport?.formatedData) || []
        }
        columns={CustomerDataReportColumn}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <RoundedDropdown
              options={orgUnitsList?.data || []}
              onSelect={(e: any) =>
                setFilterData((prev: any) => ({ ...prev, orgUnitId: e.id }))
              }
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />

            <CustomDropdown
              DropdownLabel="All"
              placeholder="Select Position"
              value={filterData.positionId}
              onChange={(id) => {
                setFilterData((prev: any) => ({
                  ...prev,
                  positionId: id,
                }));
              }}
              fetchData={async ({ page, limit, search }) => {
                const res = await getPositionList({ page, limit, search });
                let formatedData = Array.isArray(res.rowData.data.Positions)
                  ? res.rowData.data.Positions.map((item: any) => ({
                      id: item.PositionId,
                      label: item.PositionName,
                    }))
                  : [];

                const rowData = res.rowData.data.Positions;
                if (page == 1) {
                  formatedData = [{ id: "", lable: "All" }, ...formatedData];
                }
                const hasMore = Object.keys(rowData).length == limit;
                return {
                  data: formatedData,
                  hasMore,
                };
              }}
            />
            <RoundedDropdown
              options={outletType_DropDownData || []}
              onSelect={(e: any) =>
                setFilterData((prev: any) => ({ ...prev, outletTypeId: e.id }))
              }
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Outlet Type"
              headingColor="#2e8dd3"
            />
          </div>
        }
        handleSearch={(e: any) => handleSearch(e)}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={
          dataForCustomerReport?.rowData?.data?.Pagination?.TotalCounts || 0
        }
      />
    </div>
  );
};

export default Customer_Data_Report;

const CustomerDataReportColumn = [
  {
    name: "Employee Code",
    selector: (row: any) => row.EmployeeCode ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "First Name",
    selector: (row: any) => row.FirstName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Last Name",
    selector: (row: any) => row.LastName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Phone",
    selector: (row: any) => row.Phone ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Ood Town Code",
    selector: (row: any) => row.OodTownCode ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Division Name",
    selector: (row: any) => row.DivisionName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Code",
    selector: (row: any) => row.OutletCode ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Org Code",
    selector: (row: any) => row.OutletOrgCode ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Territory Name",
    selector: (row: any) => row.TerritoryName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Position Name",
    selector: (row: any) => row.PositionName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Beat Name",
    selector: (row: any) => row.BeatName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Tags",
    selector: (row: any) => row.Tags ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Visit Fq",
    selector: (row: any) => row.VisitFq ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Comments",
    selector: (row: any) => row.Comments ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Org Potential",
    selector: (row: any) => row.OrgPotential ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Brand Focus",
    selector: (row: any) => row.BrandFocus ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Customer Fq",
    selector: (row: any) => row.CustomerFq ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Name",
    selector: (row: any) => row.OutletName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Email",
    selector: (row: any) => row.OutletEmail ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Salutation",
    selector: (row: any) => row.OutletSalutation ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Classification",
    selector: (row: any) => row.OutletClassification ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Classification",
    selector: (row: any) => row.Classification ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Opening Date",
    selector: (row: any) => row.OutletOpeningDate ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Contact Name",
    selector: (row: any) => row.OutletContactName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Landline No",
    selector: (row: any) => row.OutletLandlineNo ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Alt Landline No",
    selector: (row: any) => row.OutletAltLandlineNo ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Contact Bday",
    selector: (row: any) => row.OutletContactBday ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Contact Anniversary",
    selector: (row: any) => row.OutletContactAnniversary ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Contact No",
    selector: (row: any) => row.OutletContactNo ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Alt Contact No",
    selector: (row: any) => row.OutletAltContactNo ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Type Name",
    selector: (row: any) => row.OutletTypeName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Potential",
    selector: (row: any) => row.OutletPotential ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Qualification",
    selector: (row: any) => row.OutletQualification ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Reg No",
    selector: (row: any) => row.OutletRegNo ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Marital Status",
    selector: (row: any) => row.OutletMaritalStatus ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Media",
    selector: (row: any) => row.OutletMedia ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Address Name",
    selector: (row: any) => row.AddressName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Address",
    selector: (row: any) => row.OutletAddress ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Street Name",
    selector: (row: any) => row.OutletStreetName ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet City",
    selector: (row: any) => row.Outletcity ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet State ",
    selector: (row: any) => row.OutletState ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Country ",
    selector: (row: any) => row.OutletCountry ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet PinCode ",
    selector: (row: any) => row.OutletPincode ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Last Visit Date ",
    selector: (row: any) => row.LastVisitDate ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Last Visit Employee ",
    selector: (row: any) => row.LastVisitEmployee ?? "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Status ",
    selector: (row: any) => row.OutletStatus ?? "-",
    sortable: true,
    width: "180px",
  },
];
